// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__1F7gD","input":"Form_input__1jqBF","btn":"Form_btn__2_HPa","big":"Form_big__3U8xv"};